import axios from "axios";
import { apiRoot } from "../../index";
import { startLoading, stopLoading } from "../../utils/loader";

export function getStripeOnboardingLink(jwt) {
  startLoading();
  return new Promise((resolve, reject) => {
    axios
      .get(apiRoot + "/api/v1/stripe/account-onboardinglink", {
        headers: {
          Authorization: jwt,
        },
      })
      .then((response) => {
        stopLoading();
        resolve(response);
      })
      .catch((e) => {
        stopLoading();
        reject(e);
      });
  });
}
